export default __webpack_public_path__ + "static/media/marauders-map-v4-gallery-01.3ff8037c.jpg";